export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "hue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Teinte"])}
      },
      "en": {
        "hue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hue"])}
      }
    }
  })
}
